/* eslint-disable no-use-before-define */
/* eslint-disable no-mixed-operators */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
// eslint-disable-next-line max-len
export default function lighterAction(showCursorCoords, isMouseDown, toolState, ctxMain, canvasMain, canvasToCursor, ctxToCursor, ctxPreview, drawLine, copyCanvas, canvasCur, returnCurrentFrame) {
  let prevX;
  let prevY;
  let colorToPaint;
  let isRightClicked;

  canvasToCursor.addEventListener('contextmenu', (e) => {
    e.preventDefault();
  });

  canvasToCursor.addEventListener('mousedown', (e) => {
    if (toolState.currentToolId === 'lighter') {
      ctxToCursor.clearRect(prevX, prevY, 1, 1);
      isMouseDown = true;
      ctxMain.beginPath();
      if (e.button === 2) {
        colorToPaint = lightnessColor(ctxMain, e, false);
        isRightClicked = true;
      } else colorToPaint = lightnessColor(ctxMain, e, true);
      ctxMain.fillStyle = colorToPaint;
      ctxMain.fillRect(e.offsetX, e.offsetY, 1, 1);
    }
  });
  canvasToCursor.addEventListener('mouseup', (e) => {
    if (toolState.currentToolId === 'lighter') {
      if (e.button === 2) isRightClicked = false;
      isMouseDown = false;
      ctxMain.beginPath();
      prevX = false;
      prevY = false;
      copyCanvas(canvasMain, canvasCur(returnCurrentFrame()));
    }
  });

  canvasToCursor.addEventListener('mouseout', () => {
    if (toolState.currentToolId === 'lighter') {
      ctxToCursor.beginPath();
      ctxToCursor.clearRect(prevX, prevY, 1, 1);
      ctxToCursor.fill();
      showCursorCoords();
    }
  });

  canvasToCursor.addEventListener('mousemove', (e) => {
    if (toolState.currentToolId === 'lighter') {
      showCursorCoords(e.offsetX, e.offsetY);
      if (isMouseDown === true) {
        if (prevX !== false && prevY !== false && ctxMain.getImageData(e.offsetX, e.offsetY, 1, 1).data[3] !== 0 && ctxMain.getImageData(prevX, prevY, 1, 1).data[3] !== 0) {
          if (prevX !== e.offsetX && prevY !== e.offsetY) drawLine(prevX, prevY, e.offsetX, e.offsetY, ctxMain, false, lightnessColor, isRightClicked);
        }
        prevX = e.offsetX;
        prevY = e.offsetY;
        ctxMain.beginPath();
        if (isRightClicked === true) colorToPaint = lightnessColor(ctxMain, e, false);
        else colorToPaint = lightnessColor(ctxMain, e, true);
        ctxMain.fillStyle = colorToPaint;
        ctxMain.fillRect(e.offsetX, e.offsetY, 1, 1);
      }
      if (isMouseDown === false) {
        ctxToCursor.beginPath();
        ctxToCursor.clearRect(prevX, prevY, 1, 1);
        ctxToCursor.fill();
        prevX = e.offsetX;
        prevY = e.offsetY;
        ctxToCursor.fillStyle = 'rgba(255,255,255, 0.5)';
        ctxToCursor.fillRect(e.offsetX, e.offsetY, 1, 1);
      }
    }
  });
}

function RGBToHSL(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;
  const cmin = Math.min(r, g, b);
  const cmax = Math.max(r, g, b);
  const delta = cmax - cmin;
  let h = 0;
  let s = 0;
  let l = 0;

  if (delta === 0) h = 0;
  else if (cmax === r) h = ((g - b) / delta) % 6;
  else if (cmax === g) h = (b - r) / delta + 2;
  else h = (r - g) / delta + 4;

  h = Math.round(h * 60);

  if (h < 0) h += 360;

  l = (cmax + cmin) / 2;
  s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);

  return [h, s, l];
}

function HSLToRGB(h, s, l) {
  s /= 100;
  l /= 100;

  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs((h / 60) % 2 - 1));
  const m = l - c / 2;
  let r = 0;
  let g = 0;
  let b = 0;

  if (h >= 0 && h < 60) {
    r = c; g = x; b = 0;
  } else if (h >= 60 && h < 120) {
    r = x; g = c; b = 0;
  } else if (h >= 120 && h < 180) {
    r = 0; g = c; b = x;
  } else if (h >= 180 && h < 240) {
    r = 0; g = x; b = c;
  } else if (h >= 240 && h < 300) {
    r = x; g = 0; b = c;
  } else if (h >= 300 && h < 360) {
    r = c; g = 0; b = x;
  }
  r = Math.round((r + m) * 255);
  g = Math.round((g + m) * 255);
  b = Math.round((b + m) * 255);

  return [r, g, b];
}

function lightnessColor(ctxMain, e, lighter) {
  const rgbaArr = ctxMain.getImageData(e.offsetX, e.offsetY, 1, 1).data;
  let rgba = `rgba(${rgbaArr[0]}, ${rgbaArr[1]}, ${rgbaArr[2]}, ${rgbaArr[3] / 255})`;
  if (rgbaArr[3] !== 0) {
    const hslArr = RGBToHSL(rgbaArr[0], rgbaArr[1], rgbaArr[2]);
    if (lighter === true) {
      if (hslArr[2] <= 95) hslArr[2] += 5;
      else hslArr[2] = 100;
    } else
    if (lighter === false) {
      if (hslArr[2] >= 5) hslArr[2] -= 5;
      else hslArr[2] = 0;
    }
    const rgbaArr2 = HSLToRGB(hslArr[0], hslArr[1], hslArr[2]);
    rgbaArr2.push(rgbaArr[3]);
    rgba = `rgba(${rgbaArr2[0]}, ${rgbaArr2[1]}, ${rgbaArr2[2]}, ${rgbaArr2[3] / 255})`;
  }
  console.log('rgba:', rgba);
  return rgba;
}
